import { ByteStreamWriter, calcTypeByteLength, UID_BYTES_PER_ELEMENT } from "flavr-common";
import { BufferMessageType } from "../MultiplayerTypes";
export class NetworkMsgPacker {
    static packCreateObjectsArrayBuffer(objects) {
        if (objects.length === 0)
            return undefined;
        let byteLength = (Uint8Array.BYTES_PER_ELEMENT + // BufferMessageType
            Uint32Array.BYTES_PER_ELEMENT // msgCount
        );
        let msgCount = 0;
        for (const obj of objects) {
            const bL = obj.constructorByteLength;
            if (obj.constructorSerialization !== undefined && bL !== undefined) {
                byteLength += (UID_BYTES_PER_ELEMENT + // netUid
                    Uint16Array.BYTES_PER_ELEMENT + // objectType
                    bL // constructorByteLength
                );
                ++msgCount;
            }
        }
        if (msgCount === 0)
            return undefined;
        const buffer = new ArrayBuffer(byteLength);
        const stream = new ByteStreamWriter(buffer);
        stream.uint8(BufferMessageType.CreateObject);
        stream.uint32(msgCount);
        for (const obj of objects) {
            if (!obj.constructorSerialization)
                continue;
            stream.uid(obj.netUid);
            stream.uint16(obj.objectType);
            obj.constructorSerialization(stream);
        }
        return buffer;
    }
    static packRemoveObjectsInArrayBuffer(objects) {
        const msgCount = objects.length;
        if (msgCount === 0)
            return undefined;
        const byteLength = Uint8Array.BYTES_PER_ELEMENT + Uint32Array.BYTES_PER_ELEMENT + UID_BYTES_PER_ELEMENT * msgCount;
        const buffer = new ArrayBuffer(byteLength);
        const stream = new ByteStreamWriter(buffer);
        stream.uint8(BufferMessageType.RemoveObject);
        stream.uint32(msgCount);
        for (const obj of objects) {
            stream.uid(obj.netUid);
        }
        return buffer;
    }
    static packRPCsInArrayBuffer(rpcs) {
        const msgCount = rpcs.length;
        if (msgCount === 0)
            return undefined;
        let byteLength = Uint8Array.BYTES_PER_ELEMENT + Uint32Array.BYTES_PER_ELEMENT;
        for (const rpc of rpcs) {
            byteLength +=
                UID_BYTES_PER_ELEMENT + // netUid
                    Uint16Array.BYTES_PER_ELEMENT + // cmdId
                    +Uint8Array.BYTES_PER_ELEMENT; // paramCount
            for (const value of rpc.params) {
                byteLength += calcTypeByteLength(value);
            }
        }
        const buffer = new ArrayBuffer(byteLength);
        const stream = new ByteStreamWriter(buffer);
        stream.uint8(BufferMessageType.RPC);
        stream.uint32(msgCount);
        for (const rpc of rpcs) {
            const paramCount = rpc.params.length;
            stream.uid(rpc.netUid);
            stream.uint16(rpc.cmdId);
            stream.uint8(paramCount);
            for (const value of rpc.params) {
                stream.type(value);
            }
        }
        return buffer;
    }
}
